import React from "react";
import { Check } from "lucide-react";

const getBorderColor = (status) => {
    switch (status) {
        case "Completed":
            return "border-green-500";
        case "In Progress":
            return "border-orange-400";
        case "Pending":
        default:
            return "border-gray-300";
    }
};

const getTextColor = (status) => {
    switch (status) {
        case "Completed":
            return "text-green-600";
        case "In Progress":
            return "text-orange-500";
        case "Pending":
        default:
            return "text-gray-400";
    }
};

const ServiceCardList = ({ services }) => {

    console.log('services ---',services);
    

    return (
        <div className="grid grid-cols-1 gap-4">
            {services?.map((service) => (
                <div key={service._id} className="bg-white rounded-md w-full border p-2">
                    {/* Header */}
                    <div className="flex items-center gap-2 mb-2">
                        <img
                            src={service?.img}
                            alt={service?.name}
                            className="w-6 h-6 object-cover rounded"
                        />
                        <div className="flex-1">
                            <h2 className="text-xs font-semibold">{service?.name}</h2>
                            <p className="text-[10px] text-gray-500">
                                {service?.service_time} | ₹{service?.price} ({service?.status})
                            </p>
                        </div>
                    </div>

                    {/* Stepper */}
                    <div className="flex flex-wrap justify-evenly items-center gap-3 px-1">
                        {service?.steps?.map((step) => {
                            console.log('step',step);
                            
                            const isCompleted = step.status === "Completed";
                            const borderColor = getBorderColor(step.status);
                            const textColor = getTextColor(step.status);
                            return (
                                <div key={step.id} className="flex flex-col items-center text-center">
                                    <div className={`relative w-10 h-10 rounded-full border ${borderColor} flex items-center justify-center`}>
                                        <span className="text-[9px] font-medium text-gray-700 text-center px-1 leading-tight">
                                            {step.stepName.length > 8
                                                ? `${step.stepName.slice(0, 8)}..`
                                                : step.stepName}
                                        </span>
                                        {isCompleted && (
                                            <Check className="w-3 h-3 text-green-600 absolute -bottom-1 -right-1 bg-white rounded-full" />
                                        )}
                                    </div>
                                    <span className={`text-[10px] mt-1 ${textColor}`}>{step.status}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ServiceCardList;
